import { createClient } from "@sanity/client";

const client = createClient({
  projectId: "1bcwop30",
  dataset: "production",
  apiVersion: "2023-05-01",
  useCdn: false, // Ensures fresh data is fetched every time
});

export default client;
